import React from "react";
import { Link } from "react-router-dom";
import "./small-card.css";
import { ConvertView, ConvertDate } from "../../helper/math";
function SmallCard({
  src,
  title,
  channelName,
  id,
  channelView,
  channelTime,
  videoDetail,
  detail,
}) {
  return (
    <Link
      onClick={() => videoDetail(detail)}
      to={`/watch?v=${id}`}
      className="smallCard"
    >
      <img src={src} alt="" />
      <div className="smallCard__text">
        <h4>{title?.length > 50 ? title.substring(0, 40) : title}</h4>
        <div>
          <span>
            {channelName?.length > 20
              ? channelName.substring(0, 10)
              : channelName}
          </span>
          <br />
          <span className="smallCard__view">{ConvertView(channelView)}</span>.
          <span className="smallCard__view">{ConvertDate(channelTime)}</span>
        </div>
      </div>
    </Link>
  );
}

export default SmallCard;
